function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "15",
  viewBox: "0 0 20 15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5 10h3a1 1 0 000-2H5a1 1 0 000 2zM17 0H3a3 3 0 00-3 3v9a3 3 0 003 3h14a3 3 0 003-3V3a3 3 0 00-3-3zm1 12a1 1 0 01-1 1H3a1 1 0 01-1-1V6h16v6zm0-8H2V3a1 1 0 011-1h14a1 1 0 011 1v1z",
  fill: "currentColor",
  fillRule: "evenodd"
})));